import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { filter } from 'rxjs/operators';
import { WatchesService } from '../services/watches.service';
import { ShiftAttachmentsQuery } from '../../../generated/graphql';
import { ConfirmDialogComponent } from '../../confirm-dialog/confirm-dialog.component';

export interface ViewShiftAttachmentsDialogData {
  shiftId: number;
}

type AttachmentItem = ShiftAttachmentsQuery['attachments'][0];

@Component({
  selector: 'app-view-shift-attachments-dialog',
  templateUrl: './view-shift-attachments-dialog.component.html',
})
export class ViewShiftAttachmentsDialogComponent implements OnInit {
  attachments: ShiftAttachmentsQuery['attachments'] = [];
  loading = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ViewShiftAttachmentsDialogData,
    private watchesService: WatchesService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.watchesService.getShiftAttachments(this.data.shiftId).subscribe(result => {
      this.attachments = result.data.attachments;
      this.loading = false;
    });
  }

  deleteAttachment(attachment: AttachmentItem): void {
    this.dialog
      .open(ConfirmDialogComponent, {
        width: '400px',
        data: {
          title: 'Eliminar documento',
          content: '¿Deseas eliminar este documento? Esta acción no se puede deshacer.',
        },
      })
      .afterClosed()
      .pipe(filter(r => r))
      .subscribe(() => {
        this.watchesService.deleteShiftAttachment(this.data.shiftId, attachment.id).subscribe(() => {
          this.attachments = this.attachments.filter(a => a.id !== attachment.id);
        });
      });
  }
}
